export const CB_KEYS_URL = 'https://keys.coinbase.com/connect';
export const WALLETLINK_URL = 'https://www.walletlink.org';
export const CBW_MOBILE_DEEPLINK_URL = 'https://go.cb-w.com/walletlink';
//# sourceMappingURL=constants.js.map